import { useQuery } from "@tanstack/react-query";
export const createMessagesQueries = (requests, queryClient) => ({
    useListMessages: (params, options = {}) => useQuery({
        queryKey: ["messages", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listMessages(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map